export const handleSrcWithQuality = ({ src, quality, sessionRoomId }: { src: string; quality: string; sessionRoomId: string }) => {
  return quality ? src?.replace(sessionRoomId, `${sessionRoomId}_${quality}p`) : src
}
